import { render, staticRenderFns } from "./ModalReviewReject.vue?vue&type=template&id=796605e6&"
import script from "./ModalReviewReject.vue?vue&type=script&lang=js&"
export * from "./ModalReviewReject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports